import { IReportService } from "../../service/report/ReportService";

export default class GetReport7DataInteractor {
  private reportService: IReportService;

  constructor(reportService) {
    this.reportService = reportService;
  }

  async execute(
    reportingPeriodId: number,
    applicantIds: number[],
    formTypeCode: string
  ) {
    return this.reportService.getReport7Data(
      reportingPeriodId,
      applicantIds,
      formTypeCode
    );
  }
}
